import {Component, computed, DestroyRef, inject, linkedSignal, model, resource, signal} from '@angular/core';
import {takeUntilDestroyed, toObservable} from '@angular/core/rxjs-interop';
import {filter, take} from 'rxjs/operators';
import {DolFlowOrchestratorConfigDto} from '../../../../core/dtos/gef/dol-flow-orchestrator-config-dto';
import {GestionGefService} from '../../../../core/services/gef/gestion-gef.service';
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-dol-flow-orchestrator-config-dialog',
  templateUrl: './dol-flow-orchestrator-config-dialog.component.html',
  standalone: false
})
export class DolFlowOrchestratorConfigDialogComponent {

  protected readonly ButtonThemeEnum = ButtonThemeEnum;

  private readonly gestionGefSvc = inject(GestionGefService);
  private readonly destroyRef    = inject(DestroyRef);

  readonly visible = model(false);
  readonly saving = signal(false);

  private readonly configResource = resource({
    loader: async () => this.gestionGefSvc.getDolFlowOrchestratorConfig()
      .pipe(take(1)).toPromise()
      .then(r => r?.one ?? null)
  });

  readonly formData = linkedSignal(() => {
    const c = this.configResource.value() ?? null;
    return {
      url: c?.url ?? '',
      clientId: c?.clientId ?? '',
      apiKey: c?.apiKey ?? '',
    };
  });

  readonly isFormValid = computed(() => {
    const f = this.formData();
    return !!f.url?.trim() && !!f.clientId?.trim() && !!f.apiKey?.trim();
  });

  constructor() {
    toObservable(this.visible)
      .pipe(filter(v => v), takeUntilDestroyed())
      .subscribe(() => this.configResource.reload());
  }

  close = (): void => this.visible.set(false);

  onChangeUrl = (e: any): void => this.formData.update(f => ({...f, url: e.value}));
  onChangeClientId = (e: any): void => this.formData.update(f => ({...f, clientId: e.value}));
  onChangeApiKey = (e: any): void => this.formData.update(f => ({...f, apiKey: e.value}));

  onSave(): void {
    if (!this.isFormValid()) {
      return;
    }
    this.saving.set(true);
    const payload: DolFlowOrchestratorConfigDto = {
      id: this.configResource.value()?.id,
      url: this.formData().url,
      clientId: this.formData().clientId,
      apiKey: this.formData().apiKey,
      actif: true,
    };
    this.gestionGefSvc.saveDolFlowOrchestratorConfig(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.saving.set(false);
          this.close();
        },
        error: () => {
          this.saving.set(false);
        }
      });
  }
}
